export default __webpack_public_path__ + "static/media/instagram.521785df.svg";